<template>
  <!-- <div v-if="!loaded" v-html="info" :style="infoStyle" />
  <div v-else>
  </div> -->
  <div :style="cssStyle">
    <!-- for svg:  width="100%" height="100%" preserveAspectRatio="none" -->
    <img v-if="imgUrl" :src="imgUrl" style="width: 100%;">
  </div>
</template>

<script>
export default {
  name: 'parallax',
  version: '0.0.1',
  props: {
    bgAttchUrl: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '100px'
    },
    borderRadius: {
      type: String,
      default: '0px'
    },
    imgUrl: {
      type: String,
      default: null
    }
  }, // props
  components: {}, // components
  data () {
    return {
      loaded: false,
      info: '... loading content!',
      infoStyle: { 'text-align': 'left', color: 'black' },
      formData: {},
      cssStyle: {
        // backgroundColor: 'red',
        backgroundImage: `url(${this.bgAttchUrl})`,
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
        borderRadius: this.borderRadius,
        height: this.height
        // transform: 'skewY(-1.5deg)'
      }
    }
  }, // data
  /* ----- vuejs hooks ----- */
  mounted () {}, // mounted
  computed: {}, // computed
  watch: {}, // watch
  methods: {} // methods
}
</script>

<style lang="scss" scoped>
</style>
